import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import Images from '../assets/AllImages';

const CONTACTUS = () => {

  const form = useRef();

  const sendEmail = (e) => {

    e.preventDefault();

    emailjs.sendForm("service_2b34sa3", "template_31us0k8", form.current, "0Yr14UhF75tJNQ2tr").then(
      () => {
        alert("Message sent successfully!");
        form.current.reset();
      },
      (error) => {
        alert("Faild to send message, please try again.", error.text);
      }
    );
  }

  return (
    <>
      <main>
        <div className="container-fluid bg-primary py-3 py-md-0">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 px-5">
              <h5 className="text-white fw-bold my-0">CONTACT</h5>
            </div>
            <div className="col-12 col-md-6 px-5 text-end d-none d-sm-block">
              <img src={Images.Vactor2} alt="" className="vector-img" />
            </div>
          </div>
        </div>
      </main>

      {/* Contact Info Section */}
      <div className="container-fluid pt-5">
        <div className="row align-items-center">
          <div className="col-12 col-lg-6 mb-4 px-1 px-lg-5 contact-section">
            <span className="subtitle">GET IN TOUCH</span>
            <h3 className="text-primary fw-bold ">Don't hesitate to contact us for more information.</h3>
            <p> We’re here to connect, support, and guide you. </p>
            <p>Whether you're a professional athlete, a parent enrolling your child in swim classes, or a visitor planning your next experience at Step Arena, we’re happy to assist.</p>
          </div>
          <div className="col-12 col-lg-6 px-0">
            <img src={Images.Contactimg1} alt="" className="img-fluid contact-image" />
          </div>
        </div>
      </div>

      {/* Contact Details Section */}
      <div className="container-fluid ps-lg-5 mb-5 contact-details-section">
        <div className="row">

          <div className="col-12 col-md-8 col-lg-5 bg-light">

            <div className="contact-detail-box mb-4 px-4 px-md-0">
              <div className="icon-box">
                <img src={Images.LocationIcon} alt="" className="icon-img" />
              </div>
              <div className="detail-text">
                <span className="subtitle">STEP ARENA</span>
                <h6 className="text-primary fw-bold">Prapa Pallatit të Drejtësisë, 500m pas Inspektoratit Policor. Prishtina e Re</h6>
              </div>
            </div>

            <div className="contact-detail-box px-4 px-md-0">
              <div className="icon-box">
                <img src={Images.MailIcon} alt="" className="icon-img" />
              </div>
              <div className="detail-text">
                <span className="subtitle">EMAIL US</span>
                <h6 className="text-primary fw-bold">support@steparena.com <br /> info@steparena.com</h6>
              </div>
            </div>

          </div>

          <div className="col-12 col-md-4 col-lg-3 bg-primary p-4 text-white text-center">
            <img src={Images.CallIcon} alt="" className="mb-4 support-icon" />
            <h6 className="fw-bold">BOOKING & SUPPORT</h6>
            <p>PHONE: +383 49 123 123 <br /> FAX: +383 0800 123 123</p>
          </div>

        </div>
      </div>

      {/* Map + Form Section */}
      <div className="contact-map-form">
        <img src={Images.Map} alt="Map" className="map-image" />

        <div className="contact-form-container mx-3 mx-lg-auto">
          <h2 className="fw-bold">Let's talk with us.</h2>
          <p>You can reach us directly through the details below, or fill out the contact form and we’ll get back to you as soon as possible.</p>

          <form ref={form} onSubmit={sendEmail}>
            <div className="row mb-3">
              <div className="col-md-6 mb-3 mb-md-0">
                <label className="form-label fw-bold">Name</label>
                <input type="text" className="form-control" placeholder="Name" name="user_name" />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Surname</label>
                <input type="text" className="form-control" placeholder="Surname" name="user_surname" />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6 mb-3 mb-md-0">
                <label className="form-label fw-bold">Email</label>
                <input type="email" className="form-control" placeholder="Email" name="user_email" />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Phone</label>
                <input type="text" className="form-control" placeholder="Phone" name="user_phone" />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Message</label>
              <textarea className="form-control" rows="5" placeholder="Message" name="message"></textarea>
            </div>

            <div className="d-grid">
              <button type="submit" className="btn btn-outline-light fw-bold" name="submit">SEND MESSAGE</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CONTACTUS;
